import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
// import Button from '../Button';
// import Form from '../Form';
// import TextInput from '../TextInput';
import './styles.scss';
import goSchoolPNG from 'resources/common/go-school.png';

const Footer = ({
  inverted,
  className,
  children,
  columnItemsOne,
  columnItemsTwo,
  columnItemsThree,
  socialNavItems,
  footerBottomNavItems,
  copyrightText,
  newsLetterText,
  ...other
}) => {
  const classNames = classnames({
    footer: true,
    className: true,
    'bg-white': false,
  });

  const footer = children ? (
    <div {...other} className={classNames} style={{ position: 'relative' }}>
      {children}
    </div>
  ) : (
    <div className={classNames} style={{ position: 'relative' }}>
      <div className="pt-md-4 pb-4">
        <div className="text-center" style={{ margin: 'auto', width: '5%', paddingBottom: '1rem' }}>
          <img className="logo" src={goSchoolPNG} alt="goSchoolLogo" />
        </div>
        <div className="text-center">
          Learn Go, Get Hired <br />The Academy of Go Developers
        </div>
      </div>
      <div className="text-center pb-3">
        <small>
          This site is protected by reCAPTCHA and the Google{' '}
          <a href="https://policies.google.com/privacy">Privacy Policy</a> and{' '}
          <a href="https://policies.google.com/terms">Terms of Service</a> apply.
        </small>
      </div>
    </div>
  );

  return footer;
};

Footer.propTypes = {
  inverted: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  labelOne: PropTypes.string,
  linkTextOne: PropTypes.string,
  linkHrefOne: PropTypes.string,
  labelTwo: PropTypes.string,
  linkTextTwo: PropTypes.string,
  linkHrefTwo: PropTypes.string,
  buttonText: PropTypes.string,
};

Footer.defaultProps = {
  labelOne: 'Need Help?',
  linkTextOne: 'Contact Bluemix Sales',
  linkHrefOne: '#',
  labelTwo: 'Estimate Monthly Cost',
  linkTextTwo: 'Cost Calculator',
  linkHrefTwo: '#',
  buttonText: 'Create',
};

export default Footer;



// WEBPACK FOOTER //
// ./src/ui/common/rebranding/components/Footer/Footer.js